import { themeGet } from '@styled-system/theme-get'; // eslint-disable-next-line import/no-namespace

import * as styledSystem from 'styled-system';
import theme from './theme';
var getKey = styledSystem.get,
    compose = styledSystem.compose,
    system = styledSystem.system;
export var get = function get(key) {
  return themeGet(key, getKey(theme, key));
}; // Common props

export var COMMON = compose(styledSystem.space, styledSystem.color, styledSystem.display); // Typography props

var whiteSpace = system({
  whiteSpace: {
    property: 'whiteSpace' // cssProperty: 'whiteSpace',

  }
});
export var TYPOGRAPHY = compose(styledSystem.typography, whiteSpace); // Border props

export var BORDER = compose(styledSystem.border, styledSystem.shadow); // Layout props

export var LAYOUT = styledSystem.layout; // Position props

export var POSITION = styledSystem.position; // Flex props

export var FLEX = styledSystem.flexbox; // Grid props

export var GRID = styledSystem.grid;